export const GET_QUOTE_CUSTOMERS_GRID_START = 'GET_QUOTE_CUSTOMERS_GRID_START';
export const GET_QUOTE_CUSTOMERS_GRID_SUCCESS = 'GET_QUOTE_CUSTOMERS_GRID_SUCCESS';
export const GET_QUOTE_CUSTOMERS_GRID_FAILED = 'GET_QUOTE_CUSTOMERS_GRID_FAILED';

export const GET_QUOTE_CUSTOMER_START = 'GET_QUOTE_CUSTOMER_START';
export const GET_QUOTE_CUSTOMER_SUCCESS = 'GET_QUOTE_CUSTOMER_SUCCESS';
export const GET_QUOTE_CUSTOMER_FAILED = 'GET_QUOTE_CUSTOMER_FAILED';

export const UPDATE_QUOTE_CUSTOMER_START = 'UPDATE_QUOTE_CUSTOMER_START';
export const UPDATE_QUOTE_CUSTOMER_SUCCESS = 'UPDATE_QUOTE_CUSTOMER_SUCCESS';
export const UPDATE_QUOTE_CUSTOMER_FAILED = 'UPDATE_QUOTE_CUSTOMER_FAILED';

export const CREATE_QUOTEPRO_CUSTOMER_START = 'CREATE_QUOTEPRO_CUSTOMER_START';
export const CREATE_QUOTEPRO_CUSTOMER_SUCCESS = 'CREATE_QUOTEPRO_CUSTOMER_SUCCESS';
export const CREATE_QUOTEPRO_CUSTOMER_FAILED = 'CREATE_QUOTEPRO_CUSTOMER_FAILED';

export const GET_QUOTEPRO_PRODUCTS_START = 'GET_QUOTEPRO_PRODUCTS_START';
export const GET_QUOTEPRO_PRODUCTS_SUCCESS = 'GET_QUOTEPRO_PRODUCTS_SUCCESS';
export const GET_QUOTEPRO_PRODUCTS_FAILED = 'GET_QUOTEPRO_PRODUCTS_FAILED';

export const GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_START = 'GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_START';
export const GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_SUCCESS = 'GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_SUCCESS';
export const GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_FAILED = 'GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_FAILED';

export const GET_QUOTE_PRODUCT_START = 'GET_QUOTE_PRODUCT_START';
export const GET_QUOTE_PRODUCT_SUCCESS = 'GET_QUOTE_PRODUCT_SUCCESS';
export const GET_QUOTE_PRODUCT_FAILED = 'GET_QUOTE_PRODUCT_FAILED';

export const GET_QUOTEPRO_PRODUCTS_EXPORT_START = 'GET_QUOTEPRO_PRODUCTS_EXPORT_START';
export const GET_QUOTEPRO_PRODUCTS_EXPORT_SUCCESS = 'GET_QUOTEPRO_PRODUCTS_EXPORT_SUCCESS';
export const GET_QUOTEPRO_PRODUCTS_EXPORT_FAILED = 'GET_QUOTEPRO_PRODUCTS_EXPORT_FAILED';

export const CLEAR_EDITABLE_QUOTE_PRODUCT_DATA = 'CLEAR_EDITABLE_QUOTE_PRODUCT_DATA';

export const GET_QUOTEPRO_GROUPS_ATTRIBUTE_START = 'GET_QUOTEPRO_GROUPS_ATTRIBUTE_START';
export const GET_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS = 'GET_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS';
export const GET_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED = 'GET_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED';

export const UPDATE_QUOTEPRO_PRODUCT_GROUPS = 'UPDATE_QUOTEPRO_PRODUCT_GROUPS';

export const UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_START = 'UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_START';
export const UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS = 'UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS';
export const UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED = 'UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED';

export const UPDATE_QUOTEPRO_LISTINGS_START = 'UPDATE_QUOTEPRO_LISTINGS_START';
export const UPDATE_QUOTEPRO_LISTINGS_SUCCESS = 'UPDATE_QUOTEPRO_LISTINGS_SUCCESS';
export const UPDATE_QUOTEPRO_LISTINGS_FAILED = 'UPDATE_QUOTEPRO_LISTINGS_FAILED';

export const SET_QUOTE_CUSTOMER_DATA = 'SET_QUOTE_CUSTOMER_DATA';
export const SET_QUOTE_MARKETING_SEGMENT_DATA = 'SET_QUOTE_MARKETING_SEGMENT_DATA';
export const SET_QUOTE_CUSTOMER_ACCOUNT_TAB = 'SET_QUOTE_CUSTOMER_ACCOUNT_TAB';

export const GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START = 'GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START';
export const GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS = 'GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS';
export const GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED = 'GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED';

export const GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START = 'GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START';
export const GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS = 'GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS';
export const GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED = 'GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED';

export const DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START = 'DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START';
export const DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS = 'DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS';
export const DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED = 'DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED';

export const RECEIVE_MARKETING_SEGMENT_QUOTE_QUEUE_TASK_UPDATE = 'RECEIVE_MARKETING_SEGMENT_QUOTE_QUEUE_TASK_UPDATE';

export const DELETE_MARKETING_SEGMENTS_QUEUE_TASK_START = 'DELETE_MARKETING_SEGMENTS_QUEUE_TASK_START';
export const DELETE_MARKETING_SEGMENTS_QUEUE_TASK_SUCCESS = 'DELETE_MARKETING_SEGMENTS_QUEUE_TASK_SUCCESS';
export const DELETE_MARKETING_SEGMENTS_QUEUE_TASK_FAILED = 'DELETE_MARKETING_SEGMENTS_QUEUE_TASK_FAILED';

export const GET_TOUCHMD_ACTIVITY_START = 'GET_TOUCHMD_ACTIVITY_START';
export const GET_TOUCHMD_ACTIVITY_SUCCESS = 'GET_TOUCHMD_ACTIVITY_SUCCESS';
export const GET_TOUCHMD_ACTIVITY_FAILED = 'GET_TOUCHMD_ACTIVITY_FAILED';

export const GET_QUOTEPRO_QUOTES_START = 'GET_QUOTEPRO_QUOTES_START';
export const GET_QUOTEPRO_QUOTES_SUCCESS = 'GET_QUOTEPRO_QUOTES_SUCCESS';
export const GET_QUOTEPRO_QUOTES_FAILED = 'GET_QUOTEPRO_QUOTES_FAILED';

export const GET_CUSTOMER_ACTIVE_QUOTE_COMBINED_START = 'GET_CUSTOMER_ACTIVE_QUOTE_COMBINED_START';
export const GET_CUSTOMER_ACTIVE_QUOTE_COMBINED_SUCCESS = 'GET_CUSTOMER_ACTIVE_QUOTE_COMBINED_SUCCESS';
export const GET_CUSTOMER_ACTIVE_QUOTE_COMBINED_FAILED = 'GET_CUSTOMER_ACTIVE_QUOTE_COMBINED_FAILED';

export const ADD_ITEMS_TO_QUOTE_START = 'ADD_ITEMS_TO_QUOTE_START';
export const ADD_ITEMS_TO_QUOTE_SUCCESS = 'ADD_ITEMS_TO_QUOTE_SUCCESS';
export const ADD_ITEMS_TO_QUOTE_FAILED = 'ADD_ITEMS_TO_QUOTE_FAILED';

export const DELETE_QUOTE_ITEM_START = 'DELETE_QUOTE_ITEM_START';
export const DELETE_QUOTE_ITEM_SUCCESS = 'DELETE_QUOTE_ITEM_SUCCESS';
export const DELETE_QUOTE_ITEM_FAILED = 'DELETE_QUOTE_ITEM_FAILED';

export const CONVERT_QUOTE_START = 'CONVERT_QUOTE_START';
export const CONVERT_QUOTE_SUCCESS = 'CONVERT_QUOTE_SUCCESS';
export const CONVERT_QUOTE_FAILED = 'CONVERT_QUOTE_FAILED';

export const GET_QUOTE_ITEMS_COMBINED_START = 'GET_QUOTE_ITEMS_COMBINED_START';
export const GET_QUOTE_ITEMS_COMBINED_SUCCESS = 'GET_QUOTE_ITEMS_COMBINED_SUCCESS';
export const GET_QUOTE_ITEMS_COMBINED_FAILED = 'GET_QUOTE_ITEMS_COMBINED_FAILED';

export const GET_CUSTOMER_AMASTY_QUOTES_START = 'GET_CUSTOMER_AMASTY_QUOTES_START';
export const GET_CUSTOMER_AMASTY_QUOTES_SUCCESS = 'GET_CUSTOMER_AMASTY_QUOTES_SUCCESS';
export const GET_CUSTOMER_AMASTY_QUOTES_FAILED = 'GET_CUSTOMER_AMASTY_QUOTES_FAILED';

export const GET_QUOTE_TOTALS_START = 'GET_QUOTE_TOTALS_START';
export const GET_QUOTE_TOTALS_SUCCESS = 'GET_QUOTE_TOTALS_SUCCESS';
export const GET_QUOTE_TOTALS_FAILED = 'GET_QUOTE_TOTALS_FAILED';

export const OPEN_CHECKOUT_START = 'OPEN_CHECKOUT_START';
export const OPEN_CHECKOUT_SUCCESS = 'OPEN_CHECKOUT_SUCCESS';
export const OPEN_CHECKOUT_FAILED = 'OPEN_CHECKOUT_FAILED';

export const GET_QUOTE_CART_BILLING_ADDRESS_START = 'GET_QUOTE_CART_BILLING_ADDRESS_START';
export const GET_QUOTE_CART_BILLING_ADDRESS_SUCCESS = 'GET_QUOTE_CART_BILLING_ADDRESS_SUCCESS';
export const GET_QUOTE_CART_BILLING_ADDRESS_FAILED = 'GET_QUOTE_CART_BILLING_ADDRESS_FAILED';

export const SET_QUOTE_CART_BILLING_ADDRESS_START = 'SET_QUOTE_CART_BILLING_ADDRESS_START';
export const SET_QUOTE_CART_BILLING_ADDRESS_SUCCESS = 'SET_QUOTE_CART_BILLING_ADDRESS_SUCCESS';
export const SET_QUOTE_CART_BILLING_ADDRESS_FAILED = 'SET_QUOTE_CART_BILLING_ADDRESS_FAILED';

export const GET_QUOTE_CART_SHIPPING_ADDRESS_START = 'GET_QUOTE_CART_SHIPPING_ADDRESS_START';
export const GET_QUOTE_CART_SHIPPING_ADDRESS_SUCCESS = 'GET_QUOTE_CART_SHIPPING_ADDRESS_SUCCESS';
export const GET_QUOTE_CART_SHIPPING_ADDRESS_FAILED = 'GET_QUOTE_CART_SHIPPING_ADDRESS_FAILED';

export const SET_QUOTE_CART_SHIPPING_ADDRESS_START = 'SET_QUOTE_CART_SHIPPING_ADDRESS_START';
export const SET_QUOTE_CART_SHIPPING_ADDRESS_SUCCESS = 'SET_QUOTE_CART_SHIPPING_ADDRESS_SUCCESS';
export const SET_QUOTE_CART_SHIPPING_ADDRESS_FAILED = 'SET_QUOTE_CART_SHIPPING_ADDRESS_FAILED';

export const GET_QUOTE_CART_PAYMENT_METHODS_START = 'GET_QUOTE_CART_PAYMENT_METHODS_START';
export const GET_QUOTE_CART_PAYMENT_METHODS_SUCCESS = 'GET_QUOTE_CART_PAYMENT_METHODS_SUCCESS';
export const GET_QUOTE_CART_PAYMENT_METHODS_FAILED = 'GET_QUOTE_CART_PAYMENT_METHODS_FAILED';

export const GET_QUOTE_CART_SHIPPING_METHODS_START = 'GET_QUOTE_CART_SHIPPING_METHODS_START';
export const GET_QUOTE_CART_SHIPPING_METHODS_SUCCESS = 'GET_QUOTE_CART_SHIPPING_METHODS_SUCCESS';
export const GET_QUOTE_CART_SHIPPING_METHODS_FAILED = 'GET_QUOTE_CART_SHIPPING_METHODS_FAILED';

export const GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_START = 'GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_START';
export const GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_SUCCESS = 'GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_SUCCESS';
export const GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_FAILED = 'GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_FAILED';

export const SET_QUOTE_CART_SHIPPING_METHOD_START = 'SET_QUOTE_CART_SHIPPING_METHOD_START';
export const SET_QUOTE_CART_SHIPPING_METHOD_SUCCESS = 'SET_QUOTE_CART_SHIPPING_METHOD_SUCCESS';
export const SET_QUOTE_CART_SHIPPING_METHOD_FAILED = 'SET_QUOTE_CART_SHIPPING_METHOD_FAILED';

export const GET_QUOTEPRO_TERMS_AND_CONDITIONS_START = 'GET_QUOTEPRO_TERMS_AND_CONDITIONS_START';
export const GET_QUOTEPRO_TERMS_AND_CONDITIONS_SUCCESS = 'GET_QUOTEPRO_TERMS_AND_CONDITIONS_SUCCESS';
export const GET_QUOTEPRO_TERMS_AND_CONDITIONS_FAILED = 'GET_QUOTEPRO_TERMS_AND_CONDITIONS_FAILED';

export const GET_TERMS_AND_CONDITIONS_LIST_START = 'GET_TERMS_AND_CONDITIONS_LIST_START';
export const GET_TERMS_AND_CONDITIONS_LIST_SUCCESS = 'GET_TERMS_AND_CONDITIONS_LIST_SUCCESS';
export const GET_TERMS_AND_CONDITIONS_LIST_FAILED = 'GET_TERMS_AND_CONDITIONS_LIST_FAILED';

export const SAVE_TERMS_AND_CONDITIONS_START = 'SAVE_TERMS_AND_CONDITIONS_START';
export const SAVE_TERMS_AND_CONDITIONS_SUCCESS = 'SAVE_TERMS_AND_CONDITIONS_SUCCESS';
export const SAVE_TERMS_AND_CONDITIONS_FAILED = 'SAVE_TERMS_AND_CONDITIONS_FAILED';

export const DELETE_TERMS_AND_CONDITIONS_START = 'DELETE_TERMS_AND_CONDITIONS_START';
export const DELETE_TERMS_AND_CONDITIONS_SUCCESS = 'DELETE_TERMS_AND_CONDITIONS_SUCCESS';
export const DELETE_TERMS_AND_CONDITIONS_FAILED = 'DELETE_TERMS_AND_CONDITIONS_FAILED';

export const QUOTEPRO_PLACE_ORDER_COMBINED_START = 'QUOTEPRO_PLACE_ORDER_COMBINED_START';
export const QUOTEPRO_PLACE_ORDER_COMBINED_SUCCESS = 'QUOTEPRO_PLACE_ORDER_COMBINED_SUCCESS';
export const QUOTEPRO_PLACE_ORDER_COMBINED_FAILED = 'QUOTEPRO_PLACE_ORDER_COMBINED_FAILED';

export const UPDATE_EDITABLE_QUOTE_PRODUCT = 'UPDATE_EDITABLE_QUOTE_PRODUCT';

export const GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_START = 'GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_START';
export const GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_SUCCESS = 'GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_SUCCESS';
export const GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_FAILED = 'GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_FAILED';

export const DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_START = 'DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_START';
export const DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS = 'DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS';
export const DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED = 'DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED';

export const UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_START = 'UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_START';
export const UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS = 'UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS';
export const UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED = 'UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED';

export const GET_QUOTEPRO_ATTRIBUTE_DATA_START = 'GET_QUOTEPRO_ATTRIBUTE_DATA_START';
export const GET_QUOTEPRO_ATTRIBUTE_DATA_SUCCESS = 'GET_QUOTEPRO_ATTRIBUTE_DATA_SUCCESS';
export const GET_QUOTEPRO_ATTRIBUTE_DATA_FAILED = 'GET_QUOTEPRO_ATTRIBUTE_DATA_FAILED';

export const CLEANUP_PAY_ADDRESSES_DATA = 'CLEANUP_PAY_ADDRESSES_DATA';

export const ADD_TO_MASS_EDIT = 'ADD_TO_MASS_EDIT';

export const GET_CUSTOMER_PUSH_CART_START = 'GET_CUSTOMER_PUSH_CART_START';
export const GET_CUSTOMER_PUSH_CART_SUCCESS = 'GET_CUSTOMER_PUSH_CART_SUCCESS';
export const GET_CUSTOMER_PUSH_CART_FAILED = 'GET_CUSTOMER_PUSH_CART_FAILED';

export const CREATE_CUSTOMER_PUSH_CART_START = 'CREATE_CUSTOMER_PUSH_CART_START';
export const CREATE_CUSTOMER_PUSH_CART_SUCCESS = 'CREATE_CUSTOMER_PUSH_CART_SUCCESS';
export const CREATE_CUSTOMER_PUSH_CART_FAILED = 'CREATE_CUSTOMER_PUSH_CART_FAILED';

export const UPDATE_CUSTOMER_PUSH_CART_START = 'UPDATE_CUSTOMER_PUSH_CART_START';
export const UPDATE_CUSTOMER_PUSH_CART_SUCCESS = 'UPDATE_CUSTOMER_PUSH_CART_SUCCESS';
export const UPDATE_CUSTOMER_PUSH_CART_FAILED = 'UPDATE_CUSTOMER_PUSH_CART_FAILED';

export const PUBLISH_PUSH_CART_ITEMS_START = 'PUBLISH_PUSH_CART_ITEMS_START';
export const PUBLISH_PUSH_CART_ITEMS_SUCCESS = 'PUBLISH_PUSH_CART_ITEMS_SUCCESS';
export const PUBLISH_PUSH_CART_ITEMS_FAILED = 'PUBLISH_PUSH_CART_ITEMS_FAILED';

export const PUBLISH_PUSHCART_TREATMENTS_START = 'PUBLISH_PUSHCART_TREATMENTS_START';
export const PUBLISH_PUSHCART_TREATMENTS_SUCCESS = 'PUBLISH_PUSHCART_TREATMENTS_SUCCESS';
export const PUBLISH_PUSHCART_TREATMENTS_FAILED = 'PUBLISH_PUSHCART_TREATMENTS_FAILED';

export const CREATE_PATIENTS_GROUP_QUOTE_START = 'CREATE_PATIENTS_GROUP_QUOTE_START';
export const CREATE_PATIENTS_GROUP_QUOTE_SUCCESS = 'CREATE_PATIENTS_GROUP_QUOTE_SUCCESS';
export const CREATE_PATIENTS_GROUP_QUOTE_FAILED = 'CREATE_PATIENTS_GROUP_QUOTE_FAILED';

export const CREATE_ACTIVE_CART_COMBINED_START = 'CREATE_ACTIVE_CART_COMBINED_START';
export const CREATE_ACTIVE_CART_COMBINED_SUCCESS = 'CREATE_ACTIVE_CART_COMBINED_SUCCESS';
export const CREATE_ACTIVE_CART_COMBINED_FAILED = 'CREATE_ACTIVE_CART_COMBINED_FAILED';

export const GET_CUSTOMER_SUBSCRIPTIONS_START = 'GET_CUSTOMER_SUBSCRIPTIONS_START';
export const GET_CUSTOMER_SUBSCRIPTIONS_SUCCESS = 'GET_CUSTOMER_SUBSCRIPTIONS_SUCCESS';
export const GET_CUSTOMER_SUBSCRIPTIONS_FAILED = 'GET_CUSTOMER_SUBSCRIPTIONS_FAILED';

export const SET_FINAL_PAGE_DATA = 'SET_FINAL_PAGE_DATA';
export const SET_PATIENTS_GROUP_CART = 'SET_PATIENTS_GROUP_CART';

export const CREATE_QUOTEPRO_PACKAGE_START = 'CREATE_QUOTEPRO_PACKAGE_START';
export const CREATE_QUOTEPRO_PACKAGE_SUCCESS = 'CREATE_QUOTEPRO_PACKAGE_SUCCESS';
export const CREATE_QUOTEPRO_PACKAGE_FAILED = 'CREATE_QUOTEPRO_PACKAGE_FAILED';

export const GET_QUOTEPRO_PACKAGES_START = 'GET_QUOTEPRO_PACKAGES_START';
export const GET_QUOTEPRO_PACKAGES_SUCCESS = 'GET_QUOTEPRO_PACKAGES_SUCCESS';
export const GET_QUOTEPRO_PACKAGES_FAILED = 'GET_QUOTEPRO_PACKAGES_FAILED';

export const DELETE_QUOTEPRO_PACKAGE_START = 'DELETE_QUOTEPRO_PACKAGE_START';
export const DELETE_QUOTEPRO_PACKAGE_SUCCESS = 'DELETE_QUOTEPRO_PACKAGE_SUCCESS';
export const DELETE_QUOTEPRO_PACKAGE_FAILED = 'DELETE_QUOTEPRO_PACKAGE_FAILED';

export const CONFIGURE_TREATMENT_PLAN = 'CONFIGURE_TREATMENT_PLAN';
export const UPDATE_QUOTE_PLAN_SELECTED_SERIES = 'UPDATE_QUOTE_PLAN_SELECTED_SERIES';
export const TOGGLE_SELECT_ALL_QUOTE_PLAN_SERIES = 'TOGGLE_SELECT_ALL_QUOTE_PLAN_SERIES';
export const SET_QUOTE_PLAN_SERIES_NAME = 'SET_QUOTE_PLAN_SERIES_NAME';

export const GET_TIMEZONE_CONFIG_START = 'GET_TIMEZONE_CONFIG_START';
export const GET_TIMEZONE_CONFIG_SUCCESS = 'GET_TIMEZONE_CONFIG_SUCCESS';
export const GET_TIMEZONE_CONFIG_FAILED = 'GET_TIMEZONE_CONFIG_FAILED';

export const CREATE_QUOTE_PDF_PREVIEW_START = 'CREATE_QUOTE_PDF_PREVIEW_START';
export const CREATE_QUOTE_PDF_PREVIEW_SUCCESS = 'CREATE_QUOTE_PDF_PREVIEW_SUCCESS';
export const CREATE_QUOTE_PDF_PREVIEW_FAILED = 'CREATE_QUOTE_PDF_PREVIEW_FAILED';

export const CREATE_DRAFT_QUOTE_START = 'CREATE_DRAFT_QUOTE_START';
export const CREATE_DRAFT_QUOTE_SUCCESS = 'CREATE_DRAFT_QUOTE_SUCCESS';
export const CREATE_DRAFT_QUOTE_FAILED = 'CREATE_DRAFT_QUOTE_FAILED';

export const GET_DRAFT_QUOTES_BY_CUSTOMER_START = 'GET_DRAFT_QUOTES_BY_CUSTOMER_START';
export const GET_DRAFT_QUOTES_BY_CUSTOMER_SUCCESS = 'GET_DRAFT_QUOTES_BY_CUSTOMER_SUCCESS';
export const GET_DRAFT_QUOTES_BY_CUSTOMER_FAILED = 'GET_DRAFT_QUOTES_BY_CUSTOMER_FAILED';

export const OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_START = 'OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_START';
export const OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_SUCCESS = 'OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_SUCCESS';
export const OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_FAILED = 'OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_FAILED';

export const PUBLISH_DRAFT_QUOTE_BY_ID_START = 'PUBLISH_DRAFT_QUOTE_BY_ID_START';
export const PUBLISH_DRAFT_QUOTE_BY_ID_SUCCESS = 'PUBLISH_DRAFT_QUOTE_BY_ID_SUCCESS';
export const PUBLISH_DRAFT_QUOTE_BY_ID_FAILED = 'PUBLISH_DRAFT_QUOTE_BY_ID_FAILED';

export const CREATE_DRAFT_QUOTE_PDF_PREVIEW_START = 'CREATE_DRAFT_QUOTE_PDF_PREVIEW_START';
export const CREATE_DRAFT_QUOTE_PDF_PREVIEW_SUCCESS = 'CREATE_DRAFT_QUOTE_PDF_PREVIEW_SUCCESS';
export const CREATE_DRAFT_QUOTE_PDF_PREVIEW_FAILED = 'CREATE_DRAFT_QUOTE_PDF_PREVIEW_FAILED';

export const CREATE_RECENT_QUOTE_PDF_PREVIEW_START = 'CREATE_RECENT_QUOTE_PDF_PREVIEW_START';
export const CREATE_RECENT_QUOTE_PDF_PREVIEW_SUCCESS = 'CREATE_RECENT_QUOTE_PDF_PREVIEW_SUCCESS';
export const CREATE_RECENT_QUOTE_PDF_PREVIEW_FAILED = 'CREATE_RECENT_QUOTE_PDF_PREVIEW_FAILED';

export const DOWNLOAD_DRAFT_QUOTE_PDF_START = 'DOWNLOAD_DRAFT_QUOTE_PDF_START';
export const DOWNLOAD_DRAFT_QUOTE_PDF_SUCCESS = 'DOWNLOAD_DRAFT_QUOTE_PDF_SUCCESS';
export const DOWNLOAD_DRAFT_QUOTE_PDF_FAILED = 'DOWNLOAD_DRAFT_QUOTE_PDF_FAILED';

export const DOWNLOAD_RECENT_QUOTE_PDF_START = 'DOWNLOAD_RECENT_QUOTE_PDF_START';
export const DOWNLOAD_RECENT_QUOTE_PDF_SUCCESS = 'DOWNLOAD_RECENT_QUOTE_PDF_SUCCESS';
export const DOWNLOAD_RECENT_QUOTE_PDF_FAILED = 'DOWNLOAD_RECENT_QUOTE_PDF_FAILED';

export const UPDATE_DRAFT_QUOTE_BY_ID_START = 'UPDATE_DRAFT_QUOTE_BY_ID_START';
export const UPDATE_DRAFT_QUOTE_BY_ID_SUCCESS = 'UPDATE_DRAFT_QUOTE_BY_ID_SUCCESS';
export const UPDATE_DRAFT_QUOTE_BY_ID_FAILED = 'UPDATE_DRAFT_QUOTE_BY_ID_FAILED';

export const SET_SELECTED_DRAFTED_QUOTE = 'SET_SELECTED_DRAFTED_QUOTE';

export const DOWNLOAD_QUOTE_PDF_START = 'DOWNLOAD_QUOTE_PDF_START';
export const DOWNLOAD_QUOTE_PDF_SUCCESS = 'DOWNLOAD_QUOTE_PDF_SUCCESS';
export const DOWNLOAD_QUOTE_PDF_FAILED = 'DOWNLOAD_QUOTE_PDF_FAILED';

export const GET_DEAL_TASKS_START = 'GET_DEAL_TASKS_START';
export const GET_DEAL_TASKS_SUCCESS = 'GET_DEAL_TASKS_SUCCESS';
export const GET_DEAL_TASKS_FAILED = 'GET_DEAL_TASKS_FAILED';

export const CREATE_DEAL_TASK_START = 'CREATE_DEAL_TASK_START';
export const CREATE_DEAL_TASK_SUCCESS = 'CREATE_DEAL_TASK_SUCCESS';
export const CREATE_DEAL_TASK_FAILED = 'CREATE_DEAL_TASK_FAILED';

export const UPDATE_DEAL_TASK_START = 'UPDATE_DEAL_TASK_START';
export const UPDATE_DEAL_TASK_SUCCESS = 'UPDATE_DEAL_TASK_SUCCESS';
export const UPDATE_DEAL_TASK_FAILED = 'UPDATE_DEAL_TASK_FAILED';

export const DELETE_DEAL_TASK_START = 'DELETE_DEAL_TASK_START';
export const DELETE_DEAL_TASK_SUCCESS = 'DELETE_DEAL_TASK_SUCCESS';
export const DELETE_DEAL_TASK_FAILED = 'DELETE_DEAL_TASK_FAILED';

export const GET_DEAL_ACTIVITIES_START = 'GET_DEAL_ACTIVITIES_START';
export const GET_DEAL_ACTIVITIES_SUCCESS = 'GET_DEAL_ACTIVITIES_SUCCESS';
export const GET_DEAL_ACTIVITIES_FAILED = 'GET_DEAL_ACTIVITIES_FAILED';

export const CREATE_DEAL_ACTIVITY_START = 'CREATE_DEAL_ACTIVITY_START';
export const CREATE_DEAL_ACTIVITY_SUCCESS = 'CREATE_DEAL_ACTIVITY_SUCCESS';
export const CREATE_DEAL_ACTIVITY_FAILED = 'CREATE_DEAL_ACTIVITY_FAILED';

export const UPDATE_DEAL_ACTIVITY_START = 'UPDATE_DEAL_ACTIVITY_START';
export const UPDATE_DEAL_ACTIVITY_SUCCESS = 'UPDATE_DEAL_ACTIVITY_SUCCESS';
export const UPDATE_DEAL_ACTIVITY_FAILED = 'UPDATE_DEAL_ACTIVITY_FAILED';

export const DELETE_DEAL_ACTIVITY_START = 'DELETE_DEAL_ACTIVITY_START';
export const DELETE_DEAL_ACTIVITY_SUCCESS = 'DELETE_DEAL_ACTIVITY_SUCCESS';
export const DELETE_DEAL_ACTIVITY_FAILED = 'DELETE_DEAL_ACTIVITY_FAILED';

export const GET_ALL_TASKS_START = 'GET_ALL_TASKS_START';
export const GET_ALL_TASKS_SUCCESS = 'GET_ALL_TASKS_SUCCESS';
export const GET_ALL_TASKS_FAILED = 'GET_ALL_TASKS_FAILED';

export const GET_ALL_ACTIVITIES_START = 'GET_ALL_ACTIVITIES_START';
export const GET_ALL_ACTIVITIES_SUCCESS = 'GET_ALL_ACTIVITIES_SUCCESS';
export const GET_ALL_ACTIVITIES_FAILED = 'GET_ALL_ACTIVITIES_FAILED';

export const CANCEL_QUOTE_START = 'CANCEL_QUOTE_START';
export const CANCEL_QUOTE_SUCCESS = 'CANCEL_QUOTE_SUCCESS';
export const CANCEL_QUOTE_FAILED = 'CANCEL_QUOTE_FAILED';


export const getQuoteCustomersGridStart = () => ({
  type: GET_QUOTE_CUSTOMERS_GRID_START
});

export const getQuoteCustomersGridSuccess = (data) => ({
  type: GET_QUOTE_CUSTOMERS_GRID_SUCCESS,
  data
});

export const getQuoteCustomersGridFailed = (error) => ({
  type: GET_QUOTE_CUSTOMERS_GRID_FAILED,
  error
});

export const getQuoteCustomerDataStart = () => ({
  type: GET_QUOTE_CUSTOMER_START
});

export const getQuoteCustomerDataSuccess = (data) => ({
  type: GET_QUOTE_CUSTOMER_SUCCESS,
  data
});

export const getQuoteCustomerDataFailed = (error) => ({
  type: GET_QUOTE_CUSTOMER_FAILED,
  error
});

export const updateQuoteCustomerDataStart = () => ({
  type: UPDATE_QUOTE_CUSTOMER_START
});

export const updateQuoteCustomerDataSuccess = (data) => ({
  type: UPDATE_QUOTE_CUSTOMER_SUCCESS,
  data
});

export const updateQuoteCustomerDataFailed = (error) => ({
  type: UPDATE_QUOTE_CUSTOMER_FAILED,
  error
});

export const createQuoteProCustomerStart = () => ({
  type: CREATE_QUOTEPRO_CUSTOMER_START
});

export const createQuoteProCustomerSuccess = (data) => ({
  type: CREATE_QUOTEPRO_CUSTOMER_SUCCESS,
  data
});

export const createQuoteProCustomerFailed = (error) => ({
  type: CREATE_QUOTEPRO_CUSTOMER_FAILED,
  error
});

export const getQuoteProProductsStart = () => ({
  type: GET_QUOTEPRO_PRODUCTS_START
});

export const getQuoteProProductsSuccess = (products) => ({
  type: GET_QUOTEPRO_PRODUCTS_SUCCESS,
  products
});

export const getQuoteProProductsFailed = (error) => ({
  type: GET_QUOTEPRO_PRODUCTS_FAILED,
  error
});

export const getQuoteProProductsBySearchCriteriaStart = () => ({
  type: GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_START
});

export const getQuoteProProductsBySearchCriteriaSuccess = (products) => ({
  type: GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_SUCCESS,
  products
});

export const getQuoteProProductsBySearchCriteriaFailed = (error) => ({
  type: GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_FAILED,
  error
});

export const getQuoteProductStart = () => ({
  type: GET_QUOTE_PRODUCT_START
});

export const getQuoteProductSuccess = (productData) => ({
  type: GET_QUOTE_PRODUCT_SUCCESS,
  productData
});

export const getQuoteProductFailed = (error) => ({
  type: GET_QUOTE_PRODUCT_FAILED,
  error
});

export const getQuoteProProductsExportStart = () => ({
  type: GET_QUOTEPRO_PRODUCTS_EXPORT_START,
});

export const getQuoteProProductsExportSuccess = (data) => ({
  type: GET_QUOTEPRO_PRODUCTS_EXPORT_SUCCESS,
  data
});

export const getQuoteProProductsExportFailed = (error) => ({
  type: GET_QUOTEPRO_PRODUCTS_EXPORT_FAILED,
  error
});

export const clearEditableQuoteProductData = () => ({
  type: CLEAR_EDITABLE_QUOTE_PRODUCT_DATA
});

export const getQuoteProGroupsAttributeStart = () => ({
  type: GET_QUOTEPRO_GROUPS_ATTRIBUTE_START
});

export const getQuoteProGroupsAttributeSuccess = (attributeData) => ({
  type: GET_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS,
  attributeData
});

export const getQuoteProGroupsAttributeFailed = (error) => ({
  type: GET_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED,
  error
});

export const updateQuoteProductGroups = (groupIds) => ({
  type: UPDATE_QUOTEPRO_PRODUCT_GROUPS,
  groupIds
});

export const updateQuoteProGroupsAttributeStart = () => ({
  type: UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_START
});

export const updateQuoteProGroupsAttributeSuccess = (attributeData) => ({
  type: UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS,
  attributeData
});

export const updateQuoteProGroupsAttributeFailed = (error) => ({
  type: UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED,
  error
});

export const updateQuoteProListingStart = () => ({
  type: UPDATE_QUOTEPRO_LISTINGS_START
});

export const updateQuoteProListingSuccess = (product) => ({
  type: UPDATE_QUOTEPRO_LISTINGS_SUCCESS,
  product
});

export const updateQuoteProListingFailed = (error) => ({
  type: UPDATE_QUOTEPRO_LISTINGS_FAILED,
  error
});

export const getTouchmdActivityStart = () => ({
  type: GET_TOUCHMD_ACTIVITY_START
});

export const getTouchmdActivitySuccess = (data) => ({
  type: GET_TOUCHMD_ACTIVITY_SUCCESS,
  data
});

export const getTouchmdActivityFailed = (error) => ({
  type: GET_TOUCHMD_ACTIVITY_FAILED,
  error
});

export const setQuoteCustomerData = (customer) => ({
  type: SET_QUOTE_CUSTOMER_DATA,
  customer
});

export const setQuoteMarketingSegmentData = (group) => ({
  type: SET_QUOTE_MARKETING_SEGMENT_DATA,
  group
});

export const setQuoteCustomerAccountTab = (tab) => ({
  type: SET_QUOTE_CUSTOMER_ACCOUNT_TAB,
  tab
});

export const getMarketingSegmentsQuoteQueueStart = () => ({
  type: GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START
});

export const getFailedMarketingSegmentsQuoteQueueStart = () => ({
  type: GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START
});

export const getFailedMarketingSegmentsQuoteQueueSuccess = (data) => ({
  type: GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS,
  data
});

export const getFailedMarketingSegmentsQuoteQueueFailed = (error) => ({
  type: GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED,
  error
});

export const deleteFailedMarketingSegmentQueueTasksStart = () => ({
  type: DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START
});

export const deleteFailedMarketingSegmentQueueTasksSuccess = (id) => ({
  type: DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS,
  id
});

export const deleteFailedMarketingSegmentQueueTasksFailed = (error) => ({
  type: DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED,
  error
});

export const getMarketingSegmentsQuoteQueueSuccess = (data) => ({
  type: GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS,
  data
});

export const getMarketingSegmentsQuoteQueueFailed = (error) => ({
  type: GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED,
  error
});

export const deleteMarketingSegmentQueueTaskStart = () => ({
  type: DELETE_MARKETING_SEGMENTS_QUEUE_TASK_START
});

export const deleteMarketingSegmentQueueTaskSuccess = (id) => ({
  type: DELETE_MARKETING_SEGMENTS_QUEUE_TASK_SUCCESS,
  id
});

export const deleteMarketingSegmentQueueTaskFailed = (error) => ({
  type: DELETE_MARKETING_SEGMENTS_QUEUE_TASK_FAILED,
  error
});

export const receiveMarketingSegmentQuoteQueueTaskUpdate = (data) => ({
  type: RECEIVE_MARKETING_SEGMENT_QUOTE_QUEUE_TASK_UPDATE,
  data
});

export const getQuoteProQuotesApiStart = () => ({
  type: GET_QUOTEPRO_QUOTES_START
});

export const getQuoteProQuotesApiSuccess = (data, isSetUserActiveQuote) => ({
  type: GET_QUOTEPRO_QUOTES_SUCCESS,
  data,
  isSetUserActiveQuote
});

export const getQuoteProQuotesApiFailed = (error) => ({
  type: GET_QUOTEPRO_QUOTES_FAILED,
  error
});

export const getCustomerActiveQuoteCombinedStart = () => ({
  type: GET_CUSTOMER_ACTIVE_QUOTE_COMBINED_START
});

export const getCustomerActiveQuoteCombinedSuccess = (data) => ({
  type: GET_CUSTOMER_ACTIVE_QUOTE_COMBINED_SUCCESS,
  data
});

export const getCustomerActiveQuoteCombinedFailed = (error) => ({
  type: GET_CUSTOMER_ACTIVE_QUOTE_COMBINED_FAILED,
  error
});

export const addItemsToQuoteStart = () => ({
  type: ADD_ITEMS_TO_QUOTE_START
});

export const addItemsToQuoteSuccess = (data) => ({
  type: ADD_ITEMS_TO_QUOTE_SUCCESS,
  data
});

export const addItemsToQuoteFailed = (error) => ({
  type: ADD_ITEMS_TO_QUOTE_FAILED,
  error
});

export const deleteQuoteItemStart = () => ({
  type: DELETE_QUOTE_ITEM_START
});

export const deleteQuoteItemSuccess = (itemId) => ({
  type: DELETE_QUOTE_ITEM_SUCCESS,
  itemId
});

export const deleteQuoteItemFailed = (error) => ({
  type: DELETE_QUOTE_ITEM_FAILED,
  error
});

export const convertQuoteStart = () => ({
  type: CONVERT_QUOTE_START
});

export const convertQuoteSuccess = (data) => ({
  type: CONVERT_QUOTE_SUCCESS,
  data
});

export const convertQuoteFailed = (error) => ({
  type: CONVERT_QUOTE_FAILED,
  error
});

export const getQuoteItemsCombinedStart = () => ({
  type: GET_QUOTE_ITEMS_COMBINED_START
});

export const getQuoteItemsCombinedSuccess = (data) => ({
  type: GET_QUOTE_ITEMS_COMBINED_SUCCESS,
  data
});

export const getQuoteItemsCombinedFailed = (error) => ({
  type: GET_QUOTE_ITEMS_COMBINED_FAILED,
  error
});

export const getCustomerAmastyQuotesApiStart = () => ({
  type: GET_CUSTOMER_AMASTY_QUOTES_START
});

export const getCustomerAmastyQuotesApiSuccess = (data, quotesCount) => ({
  type: GET_CUSTOMER_AMASTY_QUOTES_SUCCESS,
  data,
  quotesCount
});

export const getCustomerAmastyQuotesApiFailed = (error) => ({
  type: GET_CUSTOMER_AMASTY_QUOTES_FAILED,
  error
});

export const getQuoteTotalsStart = () => ({
  type: GET_QUOTE_TOTALS_START
});

export const getQuoteTotalsSuccess = (data) => ({
  type: GET_QUOTE_TOTALS_SUCCESS,
  data
});

export const getQuoteTotalsFailed = (error) => ({
  type: GET_QUOTE_TOTALS_FAILED,
  error
});

export const openCheckoutStart = () => ({
  type: OPEN_CHECKOUT_START
});

export const openCheckoutSuccess = (data) => ({
  type: OPEN_CHECKOUT_SUCCESS,
  data
});

export const openCheckoutFailed = (error) => ({
  type: OPEN_CHECKOUT_FAILED,
  error
});

export const getQuoteCartBillingAddressStart = () => ({
  type: GET_QUOTE_CART_BILLING_ADDRESS_START
});

export const getQuoteCartBillingAddressSuccess = (data) => ({
  type: GET_QUOTE_CART_BILLING_ADDRESS_SUCCESS,
  data
});

export const getQuoteCartBillingAddressFailed = (error) => ({
  type: GET_QUOTE_CART_BILLING_ADDRESS_FAILED,
  error
});

export const setQuoteCartBillingAddressStart = () => ({
  type: SET_QUOTE_CART_BILLING_ADDRESS_START
});

export const setQuoteCartBillingAddressSuccess = (data) => ({
  type: SET_QUOTE_CART_BILLING_ADDRESS_SUCCESS,
  data
});

export const setQuoteCartBillingAddressFailed = (error) => ({
  type: SET_QUOTE_CART_BILLING_ADDRESS_FAILED,
  error
});

export const getQuoteCartShippingAddressStart = () => ({
  type: GET_QUOTE_CART_SHIPPING_ADDRESS_START
});

export const getQuoteCartShippingAddressSuccess = (data) => ({
  type: GET_QUOTE_CART_SHIPPING_ADDRESS_SUCCESS,
  data
});

export const getQuoteCartShippingAddressFailed = (error) => ({
  type: GET_QUOTE_CART_SHIPPING_ADDRESS_FAILED,
  error
});

export const setQuoteCartShippingAddressStart = () => ({
  type: SET_QUOTE_CART_SHIPPING_ADDRESS_START
});

export const setQuoteCartShippingAddressSuccess = () => ({
  type: SET_QUOTE_CART_SHIPPING_ADDRESS_SUCCESS
});

export const setQuoteCartShippingAddressFailed = (error) => ({
  type: SET_QUOTE_CART_SHIPPING_ADDRESS_FAILED,
  error
});

export const getQuoteCartPaymentsMethodsStart = () => ({
  type: GET_QUOTE_CART_PAYMENT_METHODS_START
});

export const getQuoteCartPaymentsMethodsSuccess = (data) => ({
  type: GET_QUOTE_CART_PAYMENT_METHODS_SUCCESS,
  data
});

export const getQuoteCartPaymentsMethodsFailed = (error) => ({
  type: GET_QUOTE_CART_PAYMENT_METHODS_FAILED,
  error
});

export const getQuoteCartShippingMethodsStart = () => ({
  type: GET_QUOTE_CART_SHIPPING_METHODS_START
});

export const getQuoteCartShippingMethodsSuccess = (data) => ({
  type: GET_QUOTE_CART_SHIPPING_METHODS_SUCCESS,
  data
});

export const getQuoteCartShippingMethodsFailed = (error) => ({
  type: GET_QUOTE_CART_SHIPPING_METHODS_FAILED,
  error
});

export const getQuoteCartSelectedShippingMethodStart = () => ({
  type: GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_START
});

export const getQuoteCartSelectedShippingMethodSuccess = (data) => ({
  type: GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_SUCCESS,
  data
});

export const getQuoteCartSelectedShippingMethodFailed = (error) => ({
  type: GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_FAILED,
  error
});

export const setQuoteCartShippingMethodStart = () => ({
  type: SET_QUOTE_CART_SHIPPING_METHOD_START
});

export const setQuoteCartShippingMethodSuccess = () => ({
  type: SET_QUOTE_CART_SHIPPING_METHOD_SUCCESS
});

export const setQuoteCartShippingMethodFailed = (error) => ({
  type: SET_QUOTE_CART_SHIPPING_METHOD_FAILED,
  error
});

export const quoteProPlaceOrderCombinedStart = () => ({
  type: QUOTEPRO_PLACE_ORDER_COMBINED_START
});

export const quoteProPlaceOrderCombinedSuccess = () => ({
  type: QUOTEPRO_PLACE_ORDER_COMBINED_SUCCESS
});

export const quoteProPlaceOrderCombinedFailed = (error) => ({
  type: QUOTEPRO_PLACE_ORDER_COMBINED_FAILED,
  error
});

export const getQuoteProTermsAndConditionsStart = () => ({
  type: GET_QUOTEPRO_TERMS_AND_CONDITIONS_START
});

export const getQuoteProTermsAndConditionsSuccess = (data) => ({
  type: GET_QUOTEPRO_TERMS_AND_CONDITIONS_SUCCESS,
  data
});

export const getQuoteProTermsAndConditionsFailed = (error) => ({
  type: GET_QUOTEPRO_TERMS_AND_CONDITIONS_FAILED,
  error
});

export const getTermsAndConditionsListStart = () => ({
  type: GET_TERMS_AND_CONDITIONS_LIST_START,
});

export const getTermsAndConditionsListSuccess = (data) => ({
  type: GET_TERMS_AND_CONDITIONS_LIST_SUCCESS,
  data
});

export const getTermsAndConditionsListFailed = (error) => ({
  type: GET_TERMS_AND_CONDITIONS_LIST_FAILED,
  error
});

export const saveTermsAndConditionsStart = () => ({
  type: SAVE_TERMS_AND_CONDITIONS_START,
});

export const saveTermsAndConditionsSuccess = (data) => ({
  type: SAVE_TERMS_AND_CONDITIONS_SUCCESS,
  data
});

export const saveTermsAndConditionsFailed = (error) => ({
  type: SAVE_TERMS_AND_CONDITIONS_FAILED,
  error
});

export const deleteTermsAndConditionsStart = () => ({
  type: DELETE_TERMS_AND_CONDITIONS_START,
});

export const deleteTermsAndConditionsSuccess = (id) => ({
  type: DELETE_TERMS_AND_CONDITIONS_SUCCESS,
  id
});

export const deleteTermsAndConditionsFailed = () => ({
  type: DELETE_TERMS_AND_CONDITIONS_FAILED,
});

export const updateEditableQuoteProduct = (product) => ({
  type: UPDATE_EDITABLE_QUOTE_PRODUCT,
  product
});

export const getQuoteProductSubscriptionOptionsStart = () => ({
  type: GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_START
});

export const getQuoteProductSubscriptionOptionsSuccess = (data, sku) => ({
  type: GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_SUCCESS,
  data,
  sku
});

export const getQuoteProductSubscriptionOptionsFailed = (error) => ({
  type: GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_FAILED,
  error
});

export const deleteQuoteProductSubscriptionOptionStart = () => ({
  type: DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_START
});

export const deleteQuoteProductSubscriptionOptionSuccess = (id) => ({
  type: DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS,
  id
});

export const deleteQuoteProductSubscriptionOptionFailed = (error) => ({
  type: DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED,
  error
});

export const updateQuoteProductSubscriptionOptionStart = () => ({
  type: UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_START
});

export const updateQuoteProductSubscriptionOptionSuccess = (subscriptionsResult, isNewOptions) => ({
  type: UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS,
  subscriptionsResult,
  isNewOptions
});

export const updateQuoteProductSubscriptionOptionFailed = (error) => ({
  type: UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED,
  error
});

export const getQuoteProAttributeDataStart = () => ({
  type: GET_QUOTEPRO_ATTRIBUTE_DATA_START
});

export const getQuoteProAttributeDataSuccess = (data, attributeCode) => ({
  type: GET_QUOTEPRO_ATTRIBUTE_DATA_SUCCESS,
  data,
  attributeCode
});

export const getQuoteProAttributeDataFailed = (error) => ({
  type: GET_QUOTEPRO_ATTRIBUTE_DATA_FAILED,
  error
});

export const cleanUpPayAddressesData = () => ({
  type: CLEANUP_PAY_ADDRESSES_DATA
});

export const addToMassEdit = (products) => ({
  type: ADD_TO_MASS_EDIT,
  products
});

export const getCustomerPushCartStart = () => ({
  type: GET_CUSTOMER_PUSH_CART_START
});

export const getCustomerPushCartSuccess = (data) => ({
  type: GET_CUSTOMER_PUSH_CART_SUCCESS,
  data
});

export const getCustomerPushCartFailed = (error) => ({
  type: GET_CUSTOMER_PUSH_CART_FAILED,
  error
});

export const createCustomerPushCartStart = () => ({
  type: CREATE_CUSTOMER_PUSH_CART_START
});

export const createCustomerPushCartSuccess = (data) => ({
  type: CREATE_CUSTOMER_PUSH_CART_SUCCESS,
  data
});

export const createCustomerPushCartFailed = (error) => ({
  type: CREATE_CUSTOMER_PUSH_CART_FAILED,
  error
});

export const updateCustomerPushCartStart = () => ({
  type: UPDATE_CUSTOMER_PUSH_CART_START
});

export const updateCustomerPushCartSuccess = (data) => ({
  type: UPDATE_CUSTOMER_PUSH_CART_SUCCESS,
  data
});

export const updateCustomerPushCartFailed = (error) => ({
  type: UPDATE_CUSTOMER_PUSH_CART_FAILED,
  error
});

export const publishPushCartItemsStart = () => ({
  type: PUBLISH_PUSH_CART_ITEMS_START
});

export const publishPushCartItemsSuccess = (data) => ({
  type: PUBLISH_PUSH_CART_ITEMS_SUCCESS,
  data
});

export const publishPushCartItemsFailed = (error) => ({
  type: PUBLISH_PUSH_CART_ITEMS_FAILED,
  error
});

export const publishPushCartTreatmentsStart = () => ({
  type: PUBLISH_PUSHCART_TREATMENTS_START
});

export const publishPushCartTreatmentsSuccess = (data) => ({
  type: PUBLISH_PUSHCART_TREATMENTS_SUCCESS,
  data
});

export const publishPushCartTreatmentsFailed = (error) => ({
  type: PUBLISH_PUSHCART_TREATMENTS_FAILED,
  error
});

export const createPatientsGroupQuoteStart = () => ({
  type: CREATE_PATIENTS_GROUP_QUOTE_START
});

export const createPatientsGroupQuoteSuccess = (data) => ({
  type: CREATE_PATIENTS_GROUP_QUOTE_SUCCESS,
  data
});

export const createPatientsGroupQuoteFailed = (error) => ({
  type: CREATE_PATIENTS_GROUP_QUOTE_FAILED,
  error
});

export const createActiveCartCombinedStart = () => ({
  type: CREATE_ACTIVE_CART_COMBINED_START
});

export const createActiveCartCombinedSuccess = (data) => ({
  type: CREATE_ACTIVE_CART_COMBINED_SUCCESS,
  data
});

export const createActiveCartCombinedFailed = (error) => ({
  type: CREATE_ACTIVE_CART_COMBINED_FAILED,
  error
});

export const setFinalPageData = (items, expirationDate) => ({
  type: SET_FINAL_PAGE_DATA,
  items,
  expirationDate
});

export const setPatientsGroupCart = (patientsGroupCart) => ({
  type: SET_PATIENTS_GROUP_CART,
  patientsGroupCart
});

export const getCustomerSubscriptionsStart = () => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_START
});

export const getCustomerSubscriptionsSuccess = (data) => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_SUCCESS,
  data
});

export const getCustomerSubscriptionsFailed = (error) => ({
  type: GET_CUSTOMER_SUBSCRIPTIONS_FAILED,
  error
});

export const createQuoteProPackageStart = () => ({
  type: CREATE_QUOTEPRO_PACKAGE_START
});

export const createQuoteProPackageSuccess = (data) => ({
  type: CREATE_QUOTEPRO_PACKAGE_SUCCESS,
  data
});

export const createQuoteProPackageFailed = (error) => ({
  type: CREATE_QUOTEPRO_PACKAGE_FAILED,
  error
});

export const getQuoteProPackagesStart = () => ({
  type: GET_QUOTEPRO_PACKAGES_START
});

export const getQuoteProPackagesSuccess = (data) => ({
  type: GET_QUOTEPRO_PACKAGES_SUCCESS,
  data
});

export const getQuoteProPackagesFailed = (error) => ({
  type: GET_QUOTEPRO_PACKAGES_FAILED,
  error
});

export const deleteQuoteProPackageStart = () => ({
  type: DELETE_QUOTEPRO_PACKAGE_START
});

export const deleteQuoteProPackageSuccess = (id) => ({
  type: DELETE_QUOTEPRO_PACKAGE_SUCCESS,
  id
});

export const deleteQuoteProPackageFailed = (error) => ({
  type: DELETE_QUOTEPRO_PACKAGE_FAILED,
  error
});

export const configureTreatmentPlan = () => ({
  type: CONFIGURE_TREATMENT_PLAN
});

export const updateQuotePlanSelectedSeries = (seriesId, isChecked) => ({
  type: UPDATE_QUOTE_PLAN_SELECTED_SERIES,
  seriesId,
  isChecked
});

export const toggleSelectAllQuotePlanSeries = (isChecked) => ({
  type: TOGGLE_SELECT_ALL_QUOTE_PLAN_SERIES,
  isChecked
});

export const setQuotePlanSeriesName = (newName, seriesId) => ({
  type: SET_QUOTE_PLAN_SERIES_NAME,
  newName,
  seriesId
});

export const getTimezoneConfigStart = () => ({
  type: GET_TIMEZONE_CONFIG_START
});

export const getTimezoneConfigSuccess = (data) => ({
  type: GET_TIMEZONE_CONFIG_SUCCESS,
  data
});

export const getTimezoneConfigFailed = (error) => ({
  type: GET_TIMEZONE_CONFIG_FAILED,
  error
});

export const createQuotePdfPreviewStart = () => ({
  type: CREATE_QUOTE_PDF_PREVIEW_START
});

export const createQuotePdfPreviewSuccess = (data) => ({
  type: CREATE_QUOTE_PDF_PREVIEW_SUCCESS,
  data
});

export const createQuotePdfPreviewFailed = (error) => ({
  type: CREATE_QUOTE_PDF_PREVIEW_FAILED,
  error
});

export const createDraftQuoteStart = () => ({
  type: CREATE_DRAFT_QUOTE_START
});

export const createDraftQuoteSuccess = (data) => ({
  type: CREATE_DRAFT_QUOTE_SUCCESS,
  data
});

export const createDraftQuoteFailed = (error) => ({
  type: CREATE_DRAFT_QUOTE_FAILED,
  error
});

export const getDraftQuotesByCustomerStart = () => ({
  type: GET_DRAFT_QUOTES_BY_CUSTOMER_START
});

export const getDraftQuotesByCustomerSuccess = (data) => ({
  type: GET_DRAFT_QUOTES_BY_CUSTOMER_SUCCESS,
  data
});

export const getDraftQuotesByCustomerFailed = (error) => ({
  type: GET_DRAFT_QUOTES_BY_CUSTOMER_FAILED,
  error
});

export const openCheckoutServiceForDraftedQuoteStart = () => ({
  type: OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_START
});

export const openCheckoutServiceForDraftedQuoteSuccess = (data) => ({
  type: OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_SUCCESS,
  data
});

export const openCheckoutServiceForDraftedQuoteFailed = (error) => ({
  type: OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_FAILED,
  error
});

export const publishDraftQuoteByIdStart = () => ({
  type: PUBLISH_DRAFT_QUOTE_BY_ID_START
});

export const publishDraftQuoteByIdSuccess = (data) => ({
  type: PUBLISH_DRAFT_QUOTE_BY_ID_SUCCESS,
  data
});

export const publishDraftQuoteByIdFailed = (error) => ({
  type: PUBLISH_DRAFT_QUOTE_BY_ID_FAILED,
  error
});

export const createDraftQuotePdfPreviewStart = () => ({
  type: CREATE_DRAFT_QUOTE_PDF_PREVIEW_START
});

export const createDraftQuotePdfPreviewSuccess = (data) => ({
  type: CREATE_DRAFT_QUOTE_PDF_PREVIEW_SUCCESS,
  data
});

export const createDraftQuotePdfPreviewFailed = (error) => ({
  type: CREATE_DRAFT_QUOTE_PDF_PREVIEW_FAILED,
  error
});

export const createRecentQuotePdfPreviewStart = () => ({
  type: CREATE_RECENT_QUOTE_PDF_PREVIEW_START
});

export const createRecentQuotePdfPreviewSuccess = (data) => ({
  type: CREATE_RECENT_QUOTE_PDF_PREVIEW_SUCCESS,
  data
});

export const createRecentQuotePdfPreviewFailed = (error) => ({
  type: CREATE_RECENT_QUOTE_PDF_PREVIEW_FAILED,
  error
});

export const downloadDraftQuotePdfStart = () => ({
  type: DOWNLOAD_DRAFT_QUOTE_PDF_START
});

export const downloadDraftQuotePdfSuccess = () => ({
  type: DOWNLOAD_DRAFT_QUOTE_PDF_SUCCESS
});

export const downloadDraftQuotePdfFailed = (error) => ({
  type: DOWNLOAD_DRAFT_QUOTE_PDF_FAILED,
  error
});

export const downloadRecentQuotePdfStart = () => ({
  type: DOWNLOAD_RECENT_QUOTE_PDF_START
});

export const downloadRecentQuotePdfSuccess = () => ({
  type: DOWNLOAD_RECENT_QUOTE_PDF_SUCCESS
});

export const downloadRecentQuotePdfFailed = (error) => ({
  type: DOWNLOAD_RECENT_QUOTE_PDF_FAILED,
  error
});

export const updateDraftQuoteByIdStart = () => ({
  type: UPDATE_DRAFT_QUOTE_BY_ID_START
});

export const updateDraftQuoteByIdSuccess = (data) => ({
  type: UPDATE_DRAFT_QUOTE_BY_ID_SUCCESS,
  data
});

export const updateDraftQuoteByIdFailed = (error) => ({
  type: UPDATE_DRAFT_QUOTE_BY_ID_FAILED,
  error
});

export const setSelectedDraftedQuote = (selectedQuote) => ({
  type: SET_SELECTED_DRAFTED_QUOTE,
  selectedQuote
});

export const downloadQuotePdfStart = () => ({
  type: DOWNLOAD_QUOTE_PDF_START
});

export const downloadQuotePdfSuccess = () => ({
  type: DOWNLOAD_QUOTE_PDF_SUCCESS
});

export const downloadQuotePdfFailed = (error) => ({
  type: DOWNLOAD_QUOTE_PDF_FAILED,
  error
});

export const getDealTasksStart = () => ({
  type: GET_DEAL_TASKS_START
});

export const getDealTasksSuccess = (data, dealId) => ({
  type: GET_DEAL_TASKS_SUCCESS,
  data,
  dealId
});

export const getDealTasksFailed = (error) => ({
  type: GET_DEAL_TASKS_FAILED,
  error
});

export const createDealTaskStart = () => ({
  type: CREATE_DEAL_TASK_START
});

export const createDealTaskSuccess = (data) => ({
  type: CREATE_DEAL_TASK_SUCCESS,
  data
});

export const createDealTaskFailed = (error) => ({
  type: CREATE_DEAL_TASK_FAILED,
  error
});

export const updateDealTaskStart = () => ({
  type: UPDATE_DEAL_TASK_START
});

export const updateDealTaskSuccess = (data) => ({
  type: UPDATE_DEAL_TASK_SUCCESS,
  data
});

export const updateDealTaskFailed = (error) => ({
  type: UPDATE_DEAL_TASK_FAILED,
  error
});

export const deleteDealTaskStart = () => ({
  type: DELETE_DEAL_TASK_START
});

export const deleteDealTaskSuccess = (id, dealId) => ({
  type: DELETE_DEAL_TASK_SUCCESS,
  id,
  dealId
});

export const deleteDealTaskFailed = (error) => ({
  type: DELETE_DEAL_TASK_FAILED,
  error
});

export const getDealActivitiesStart = () => ({
  type: GET_DEAL_ACTIVITIES_START
});

export const getDealActivitiesSuccess = (data, dealId) => ({
  type: GET_DEAL_ACTIVITIES_SUCCESS,
  data,
  dealId
});

export const getDealActivitiesFailed = (error) => ({
  type: GET_DEAL_ACTIVITIES_FAILED,
  error
});

export const createDealActivityStart = () => ({
  type: CREATE_DEAL_ACTIVITY_START
});

export const createDealActivitySuccess = (data) => ({
  type: CREATE_DEAL_ACTIVITY_SUCCESS,
  data
});

export const createDealActivityFailed = (error) => ({
  type: CREATE_DEAL_ACTIVITY_FAILED,
  error
});

export const updateDealActivityStart = () => ({
  type: UPDATE_DEAL_ACTIVITY_START
});

export const updateDealActivitySuccess = (data) => ({
  type: UPDATE_DEAL_ACTIVITY_SUCCESS,
  data
});

export const updateDealActivityFailed = (error) => ({
  type: UPDATE_DEAL_ACTIVITY_FAILED,
  error
});

export const deleteDeAlactivityStart = () => ({
  type: DELETE_DEAL_ACTIVITY_START
});

export const deleteDealActivitySuccess = (id, dealId) => ({
  type: DELETE_DEAL_ACTIVITY_SUCCESS,
  id,
  dealId
});

export const deleteDealActivityFailed = (error) => ({
  type: DELETE_DEAL_ACTIVITY_FAILED,
  error
});

export const getAllTasksStart = () => ({
  type: GET_ALL_TASKS_START
});

export const getAllTasksSuccess = (data) => ({
  type: GET_ALL_TASKS_SUCCESS,
  data
});

export const getAllTasksFailed = (error) => ({
  type: GET_ALL_TASKS_FAILED,
  error
});

export const getAllActivitiesStart = () => ({
  type: GET_ALL_ACTIVITIES_START
});

export const getAllActivitiesSuccess = (data) => ({
  type: GET_ALL_ACTIVITIES_SUCCESS,
  data
});

export const getAllActivitiesFailed = (error) => ({
  type: GET_ALL_ACTIVITIES_FAILED,
  error
});

export const cancelQuoteStart = () => ({
  type: CANCEL_QUOTE_START
});

export const cancelQuoteSuccess = (quoteId) => ({
  type: CANCEL_QUOTE_SUCCESS,
  quoteId
});

export const cancelQuoteFailed = (error) => ({
  type: CANCEL_QUOTE_FAILED,
  error
});

